//
//
//
//
//
//
//
//
//
//
//
//
//

import wxPay from "@/common/js/wxPay.js"
export default {
  mixins: [wxPay],
  data() {
    return {
      creatTime: '',
      price: 0,
      orderId: '',
      weixinBridgeInfo: {}
    }
  },
  onLoad(e) {
    // this.price=parseFloat(e.price)
    // this.orderId=e.orderId
    // this.getLeftTime()
  },
  methods: {
    timeout() {
      uni.showToast({
        message: '支付失效!订单关闭，可在我的订单中查看!即将跳转...',
        icon: 'none'
      })
      setTimeout(() => {
        uni.switchTab({
          url: '/pages/personalCenter/index'
        })
      }, 2000)
    }
  }
}
